import { ReactElement, useState } from 'react'
import { HistoricalInventoryAlertValue, InventoryAlertValue } from 'redux_toolkit/apps'
import { InventoryAlertDrawer } from './InventoryAlertDrawer'
import { InventoryAlertsList } from './InventoryAlertsList'

type InventoryAlertsDrawerProps = {
    appId: string,
    appUserId?: string,
    appResourceId?: string,
    appResourceTypeId?: string,
    expandedAlert?: InventoryAlertValue,
    closeDrawer: () => void,
}

export const InventoryAlertsDrawer =
    ({ appId, appUserId, appResourceId, appResourceTypeId, expandedAlert, closeDrawer }: InventoryAlertsDrawerProps): ReactElement => {
        const [selectedAlert, setSelectedAlert] =
            useState<InventoryAlertValue | HistoricalInventoryAlertValue | null>(expandedAlert ?? null)

        const showList = (): void => {
            setSelectedAlert(null)
        }

        const showSelectedAlert = (alert: InventoryAlertValue | HistoricalInventoryAlertValue): void => {
            setSelectedAlert(alert)
        }

        return selectedAlert ?
            <InventoryAlertDrawer expandedAlert={selectedAlert} closeDrawer={closeDrawer} showList={showList} />
            : <InventoryAlertsList
                appId={appId}
                appUserId={appUserId}
                appResourceId={appResourceId}
                appResourceTypeId={appResourceTypeId}
                closeDrawer={closeDrawer}
                showSelectedAlert={showSelectedAlert}
            />
    }
